// sections/SectionOSHC.jsx
import React from 'react';
import { Heart } from 'lucide-react';
import { Row, Col, Select, SectionTitle, FormField } from '../../../SharedInputs.jsx';

export function SectionOSHC({ value, onChange, errors = [] }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div>
      <SectionTitle icon={Heart} step={8}>Overseas Student Health Cover (OSHC)</SectionTitle>
      
      <div style={{
        padding: 16,
        background: '#f0fdf4',
        borderRadius: 8,
        border: '1px solid #bbf7d0',
        marginBottom: 24
      }}>
        <p style={{ margin: 0, fontSize: 14, color: '#065f46' }}>
          Overseas Student Health Cover (OSHC) is mandatory for all international students 
          in Australia. CIET can arrange this for you or you may organize it independently.
        </p>
      </div>

      <Row>
        <Col span={6}>
          <FormField label="Would you like CIET to arrange OSHC for you?">
            <Select value={value.arrangeOSHC} onChange={(e) => updateField('arrangeOSHC', e.target.value)}>
              <option value="Yes">Yes, please arrange OSHC</option>
              <option value="No">No, I will arrange independently</option>
            </Select>
          </FormField>
        </Col>
        <Col span={6}>
          <FormField label="Coverage type required">
            <Select value={value.coverType} onChange={(e) => updateField('coverType', e.target.value)}>
              <option value="Single">Single</option>
              <option value="Couple">Couple</option>
              <option value="Family">Family</option>
            </Select>
          </FormField>
        </Col>
      </Row>
    </div>
  );
}